import axios from "axios"
import { handleError } from "./utils/errors/errorHandler";

const API = process.env.REACT_APP_API_URL
export const FRONT = process.env.REACT_APP_FRONT_URL

export const api = axios.create({
    baseURL: API,
    withCredentials: true
})
api.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config

        // Refresh token logic
        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true

            try {
                await api.post("/auth/refresh", {}, { withCredentials: true })

                return api(originalRequest)
            } catch (refreshError) {
                window.location.href = "/"
            }
        }

        // Global error handling. A request can opt out (e.g. a 409 the caller handles itself, like
        // resuming an in-progress generation) by setting `suppressErrorToast` on its config.
        if (!originalRequest?.suppressErrorToast) {
            const message =
                error?.response?.data?.message ||
                error?.message ||
                "Unexpected API error"

            handleError(message)
        }

        // Continue
        return Promise.reject(error);
    }
);

export const s3 = axios.create()